// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Root ─────────────────────────────────────────────────────────────── */
.dsd-root {
  position: fixed;
  inset: 0;
  z-index: 9999;
  font-family: 'Epilogue', 'Inter', sans-serif;
  background: #060c16;
  color: #f1f5f9;
  overflow: hidden;
}

.dsd-screen {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  animation: dsd-fade-in 0.4s cubic-bezier(0.22, 0.61, 0.36, 1) both;
}

@keyframes dsd-fade-in {
  from { opacity: 0; transform: translateY(16px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* ── Idle Screen ──────────────────────────────────────────────────────── */
.dsd-idle {
  align-items: center;
  justify-content: center;
  background: radial-gradient(ellipse at 30% 40%, #0f2744 0%, #060c16 60%),
              radial-gradient(ellipse at 75% 65%, #0c1f3a 0%, transparent 55%);
}

.dsd-idle-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  opacity: 0.25;
  pointer-events: none;
}
.dsd-idle-orb-1 { width: 480px; height: 480px; background: #1d4ed8; top: -120px; left: -80px; animation: dsd-float 8s ease-in-out infinite; }
.dsd-idle-orb-2 { width: 360px; height: 360px; background: #7c3aed; bottom: -80px; right: -60px; animation: dsd-float 10s ease-in-out infinite reverse; }
.dsd-idle-orb-3 { width: 240px; height: 240px; background: #0369a1; top: 50%; right: 20%; animation: dsd-float 12s ease-in-out infinite 2s; }

@keyframes dsd-float {
  0%, 100% { transform: translateY(0) scale(1); }
  50%       { transform: translateY(-30px) scale(1.05); }
}

.dsd-idle-content {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  text-align: center;
  padding: 0 24px;
}

.dsd-idle-avatar {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  background: linear-gradient(135deg, #1d4ed8, #7c3aed);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2.4rem;
  font-weight: 800;
  color: #fff;
  box-shadow: 0 0 0 12px rgba(29, 78, 216, 0.12), 0 20px 60px rgba(0,0,0,0.5);
  margin-bottom: 8px;
}

.dsd-idle-store {
  font-size: clamp(2rem, 5vw, 3.6rem);
  font-weight: 800;
  letter-spacing: -0.02em;
  color: #fff;
  margin: 0;
}

.dsd-idle-tagline {
  font-size: 1.1rem;
  color: #94a3b8;
  margin: 0;
}

.dsd-idle-dots {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}
.dsd-idle-dots span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #3b82f6;
  animation: dsd-pulse 1.4s ease-in-out infinite;
}
.dsd-idle-dots span:nth-child(2) { animation-delay: 0.2s; }
.dsd-idle-dots span:nth-child(3) { animation-delay: 0.4s; }
@keyframes dsd-pulse { 0%,100% { opacity: 0.3; transform: scale(0.85); } 50% { opacity: 1; transform: scale(1); } }

.dsd-idle-mode-btn {
  position: absolute;
  bottom: 24px;
  right: 24px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  border-radius: 999px;
  border: 1px solid rgba(255,255,255,0.12);
  background: rgba(255,255,255,0.06);
  color: #94a3b8;
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  backdrop-filter: blur(8px);
  transition: background 0.2s, color 0.2s, border-color 0.2s;
}
.dsd-idle-mode-btn:hover { background: rgba(255,255,255,0.12); color: #e2e8f0; border-color: rgba(255,255,255,0.2); }

/* Continue button shown after phone lookup result */
.dsd-phone-continue-btn {
  margin-top: 28px;
  padding: 16px 48px;
  border-radius: 999px;
  border: none;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  color: #fff;
  font-size: 1.1rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  cursor: pointer;
  box-shadow: 0 4px 24px rgba(99,102,241,0.35);
  transition: transform 0.15s, box-shadow 0.15s;
}
.dsd-phone-continue-btn:hover { transform: translateY(-2px); box-shadow: 0 8px 32px rgba(99,102,241,0.5); }
.dsd-phone-continue-btn:active { transform: translateY(0); }

/* ── Phone Screen ─────────────────────────────────────────────────────── */
.dsd-phone {
  align-items: center;
  justify-content: flex-start;
  padding: 40px 24px 80px;
  gap: 28px;
  background: radial-gradient(ellipse at 50% 0%, #0f2744 0%, #060c16 70%);
  overflow-y: auto;
}

.dsd-phone-header {
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.dsd-phone-store { font-size: 0.85rem; font-weight: 600; color: #60a5fa; letter-spacing: 0.08em; text-transform: uppercase; margin: 0; }
.dsd-phone-title { font-size: clamp(1.5rem, 3vw, 2.2rem); font-weight: 800; margin: 0; color: #f8fafc; }
.dsd-phone-sub   { font-size: 0.95rem; color: #94a3b8; margin: 0; }

.dsd-phone-display-wrap {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 72px;
  padding: 16px 32px;
  border-radius: 16px;
  background: rgba(255,255,255,0.05);
  border: 1.5px solid rgba(255,255,255,0.1);
  width: 100%;
  max-width: 420px;
}
.dsd-phone-placeholder { font-size: 1.6rem; letter-spacing: 0.25em; color: #475569; }
.dsd-phone-value { font-size: 2rem; font-weight: 700; letter-spacing: 0.18em; color: #f1f5f9; }
.dsd-phone-searching {
  position: absolute;
  bottom: 0; left: 0; right: 0;
  height: 3px;
  border-radius: 0 0 16px 16px;
  background: linear-gradient(90deg, transparent, #60a5fa, transparent);
  animation: dsd-scan 1.2s linear infinite;
}
@keyframes dsd-scan { 0% { background-position: -200% 0; } 100% { background-position: 200% 0; } }

.dsd-phone-result {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 18px 24px;
  border-radius: 16px;
  width: 100%;
  max-width: 420px;
  animation: dsd-fade-in 0.35s ease both;
}
.dsd-phone-result-found { background: rgba(34, 197, 94, 0.12); border: 1px solid rgba(34, 197, 94, 0.25); }
.dsd-phone-result-new   { background: rgba(96, 165, 250, 0.1);  border: 1px solid rgba(96, 165, 250, 0.2); color: #93c5fd; font-size: 0.95rem; }

.dsd-phone-result-avatar {
  width: 48px; height: 48px;
  border-radius: 50%;
  background: linear-gradient(135deg, #16a34a, #15803d);
  display: flex; align-items: center; justify-content: center;
  font-size: 1.3rem; font-weight: 800; color: #fff;
  flex-shrink: 0;
}
.dsd-phone-result-name { font-size: 1.05rem; font-weight: 700; color: #f0fdf4; margin: 0 0 4px; }
.dsd-phone-result-pts  { font-size: 0.85rem; color: #86efac; margin: 0; }

.dsd-keypad {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  width: 100%;
  max-width: 380px;
}
.dsd-key {
  height: 72px;
  border-radius: 14px;
  border: 1.5px solid rgba(255,255,255,0.1);
  background: rgba(255,255,255,0.06);
  color: #f1f5f9;
  font-size: 1.6rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.12s, transform 0.1s;
  backdrop-filter: blur(6px);
}
.dsd-key:hover:not(:disabled) { background: rgba(255,255,255,0.12); }
.dsd-key:active:not(:disabled) { transform: scale(0.95); }
.dsd-key:disabled { opacity: 0.4; cursor: not-allowed; }
.dsd-key-skip { font-size: 1rem; font-weight: 700; color: #94a3b8; letter-spacing: 0.04em; border-color: rgba(255,255,255,0.07); }
.dsd-key-back { font-size: 1.4rem; color: #94a3b8; }

/* ── Cart Screen ──────────────────────────────────────────────────────── */
.dsd-cart {
  background: #070d17;
  overflow: hidden;
}

.dsd-cart-topbar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 24px;
  background: rgba(255,255,255,0.03);
  border-bottom: 1px solid rgba(255,255,255,0.07);
  flex-shrink: 0;
}

.dsd-live-badge {
  font-size: 0.72rem;
  font-weight: 700;
  color: #4ade80;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  animation: dsd-live-pulse 2s ease-in-out infinite;
}
@keyframes dsd-live-pulse { 0%,100% { opacity: 1; } 50% { opacity: 0.55; } }

.dsd-cart-count { font-size: 0.85rem; color: #64748b; font-weight: 500; }

.dsd-cart-customer-pill {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px 6px 6px;
  border-radius: 999px;
  background: rgba(59, 130, 246, 0.12);
  border: 1px solid rgba(59, 130, 246, 0.25);
}
.dsd-cart-customer-av {
  width: 28px; height: 28px;
  border-radius: 50%;
  background: #1d4ed8;
  display: flex; align-items: center; justify-content: center;
  font-size: 0.78rem; font-weight: 800; color: #fff;
}
.dsd-cart-customer-name { font-size: 0.85rem; font-weight: 600; color: #93c5fd; }
.dsd-cart-loyalty-chip {
  padding: 2px 8px;
  border-radius: 999px;
  background: rgba(59,130,246,0.2);
  color: #60a5fa;
  font-size: 0.75rem;
  font-weight: 600;
}
.dsd-cart-store { margin-left: auto; font-size: 0.8rem; color: #334155; font-weight: 600; }

.dsd-cart-body {
  display: grid;
  grid-template-columns: 1fr 340px;
  gap: 0;
  flex: 1;
  overflow: hidden;
}

.dsd-cart-items-col {
  overflow: hidden;
  border-right: 1px solid rgba(255,255,255,0.06);
  display: flex;
  flex-direction: column;
}

.dsd-cart-items-list {
  overflow-y: auto;
  flex: 1;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.dsd-cart-items-list::-webkit-scrollbar { width: 4px; }
.dsd-cart-items-list::-webkit-scrollbar-track { background: transparent; }
.dsd-cart-items-list::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.1); border-radius: 4px; }

.dsd-cart-item {
  display: grid;
  grid-template-columns: 32px 1fr 56px 96px;
  align-items: center;
  gap: 12px;
  padding: 14px 12px;
  border-radius: 10px;
  transition: background 0.15s;
  animation: dsd-item-in 0.3s ease both;
}
.dsd-cart-item:hover { background: rgba(255,255,255,0.04); }
@keyframes dsd-item-in { from { opacity: 0; transform: translateX(-8px); } to { opacity: 1; transform: none; } }

.dsd-cart-item-num {
  width: 28px; height: 28px;
  border-radius: 50%;
  background: rgba(255,255,255,0.06);
  display: flex; align-items: center; justify-content: center;
  font-size: 0.75rem; font-weight: 700; color: #64748b;
  flex-shrink: 0;
}
.dsd-cart-item-name  { font-size: 1rem; font-weight: 500; color: #e2e8f0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.dsd-cart-item-qty   { font-size: 0.9rem; color: #64748b; text-align: center; }
.dsd-cart-item-price { font-size: 1rem; font-weight: 700; color: #f1f5f9; text-align: right; }

.dsd-cart-summary-col {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
  background: rgba(0,0,0,0.2);
}

.dsd-cart-summary-card {
  background: rgba(255,255,255,0.04);
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 16px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.dsd-summary-title {
  font-size: 0.75rem;
  font-weight: 700;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(255,255,255,0.06);
}

.dsd-summary-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.92rem;
  color: #94a3b8;
}
.dsd-summary-row span:last-child { color: #cbd5e1; font-weight: 500; }
.dsd-summary-row-discount { color: #4ade80; }
.dsd-summary-row-discount span:last-child { color: #4ade80; }

.dsd-summary-divider { height: 1px; background: rgba(255,255,255,0.08); }

.dsd-summary-total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 4px;
}
.dsd-summary-total span:first-child { font-size: 1rem; font-weight: 700; color: #f1f5f9; }
.dsd-summary-total span:last-child  { font-size: 1.7rem; font-weight: 800; color: #fff; }

/* ── Success Screen ───────────────────────────────────────────────────── */
.dsd-success {
  align-items: center;
  justify-content: center;
  gap: 24px;
  text-align: center;
  padding: 40px;
  background: radial-gradient(ellipse at 50% 40%, #052e16 0%, #060c16 65%);
}

.dsd-success-glow {
  position: absolute;
  width: 480px; height: 480px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(34, 197, 94, 0.18) 0%, transparent 70%);
  pointer-events: none;
  animation: dsd-glow-pulse 2s ease-in-out infinite;
}
@keyframes dsd-glow-pulse { 0%,100% { transform: scale(1); opacity: 1; } 50% { transform: scale(1.15); opacity: 0.7; } }

.dsd-success-ring {
  width: 120px; height: 120px;
  position: relative;
  z-index: 1;
}
.dsd-success-svg { width: 100%; height: 100%; }

.dsd-success-circle {
  stroke: #22c55e;
  stroke-dasharray: 151;
  stroke-dashoffset: 151;
  transform-origin: 50% 50%;
  animation: dsd-circle-draw 0.65s cubic-bezier(0.65, 0, 0.45, 1) 0.1s forwards;
}
@keyframes dsd-circle-draw { to { stroke-dashoffset: 0; } }

.dsd-success-check {
  stroke: #22c55e;
  stroke-dasharray: 60;
  stroke-dashoffset: 60;
  animation: dsd-check-draw 0.35s cubic-bezier(0.65, 0, 0.45, 1) 0.75s forwards;
}
@keyframes dsd-check-draw { to { stroke-dashoffset: 0; } }

.dsd-success-title {
  font-size: clamp(1.8rem, 4vw, 3rem);
  font-weight: 800;
  color: #fff;
  margin: 0;
  animation: dsd-fade-in 0.5s ease 0.8s both;
}
.dsd-success-sub {
  font-size: 1.05rem;
  color: #86efac;
  margin: 0;
  animation: dsd-fade-in 0.5s ease 1s both;
}
.dsd-success-amount {
  font-size: clamp(2rem, 5vw, 3.5rem);
  font-weight: 900;
  color: #4ade80;
  letter-spacing: -0.02em;
  animation: dsd-fade-in 0.5s ease 1.1s both;
}

.dsd-success-timer-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  animation: dsd-fade-in 0.5s ease 1.3s both;
  margin-top: 8px;
}
.dsd-success-timer-bar {
  width: 200px; height: 3px;
  border-radius: 999px;
  background: rgba(255,255,255,0.1);
  overflow: hidden;
}
.dsd-success-timer-fill {
  height: 100%;
  background: #22c55e;
  border-radius: 999px;
  animation: dsd-timer-shrink 7s linear forwards;
}
@keyframes dsd-timer-shrink { from { width: 100%; } to { width: 0%; } }
.dsd-success-timer-label { font-size: 0.78rem; color: #475569; }
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/settings/components/DualScreenDisplay/index.css"],"names":[],"mappings":"AAAA,4EAA4E;AAC5E;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,4CAA4C;EAC5C,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA,4EAA4E;AAC5E;EACE,mBAAmB;EACnB,uBAAuB;EACvB;8EAC4E;AAC9E;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,oBAAoB;AACtB;AACA,kBAAkB,YAAY,EAAE,aAAa,EAAE,mBAAmB,EAAE,WAAW,EAAE,WAAW,EAAE,4CAA4C,EAAE;AAC5I,kBAAkB,YAAY,EAAE,aAAa,EAAE,mBAAmB,EAAE,aAAa,EAAE,YAAY,EAAE,qDAAqD,EAAE;AACxJ,kBAAkB,YAAY,EAAE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,UAAU,EAAE,gDAAgD,EAAE;;AAE5I;EACE,WAAW,iCAAiC,EAAE;EAC9C,YAAY,wCAAwC,EAAE;AACxD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,2EAA2E;EAC3E,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,8CAA8C;AAChD;AACA,mCAAmC,qBAAqB,EAAE;AAC1D,mCAAmC,qBAAqB,EAAE;AAC1D,uBAAuB,UAAU,YAAY,EAAE,sBAAsB,EAAE,EAAE,MAAM,UAAU,EAAE,mBAAmB,EAAE,EAAE;;AAElH;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,oBAAoB;EACpB,wCAAwC;EACxC,kCAAkC;EAClC,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,0DAA0D;AAC5D;AACA,2BAA2B,kCAAkC,EAAE,cAAc,EAAE,mCAAmC,EAAE;;AAEpH,oDAAoD;AACpD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,qDAAqD;EACrD,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,4CAA4C;EAC5C,6CAA6C;AAC/C;AACA,gCAAgC,2BAA2B,EAAE,2CAA2C,EAAE;AAC1G,iCAAiC,wBAAwB,EAAE;;AAE3D,4EAA4E;AAC5E;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,SAAS;EACT,uEAAuE;EACvE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA,mBAAmB,kBAAkB,EAAE,gBAAgB,EAAE,cAAc,EAAE,sBAAsB,EAAE,yBAAyB,EAAE,SAAS,EAAE;AACvI,mBAAmB,qCAAqC,EAAE,gBAAgB,EAAE,SAAS,EAAE,cAAc,EAAE;AACvG,mBAAmB,kBAAkB,EAAE,cAAc,EAAE,SAAS,EAAE;;AAElE;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,yCAAyC;EACzC,WAAW;EACX,gBAAgB;AAClB;AACA,yBAAyB,iBAAiB,EAAE,sBAAsB,EAAE,cAAc,EAAE;AACpF,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,cAAc,EAAE;AAC9F;EACE,kBAAkB;EAClB,SAAS,EAAE,OAAO,EAAE,QAAQ;EAC5B,WAAW;EACX,4BAA4B;EAC5B,qEAAqE;EACrE,wCAAwC;AAC1C;AACA,sBAAsB,KAAK,4BAA4B,EAAE,EAAE,OAAO,2BAA2B,EAAE,EAAE;;AAEjG;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,sCAAsC;AACxC;AACA,0BAA0B,mCAAmC,EAAE,yCAAyC,EAAE;AAC1G,0BAA0B,mCAAmC,GAAG,yCAAyC,EAAE,cAAc,EAAE,kBAAkB,EAAE;;AAE/I;EACE,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,qDAAqD;EACrD,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,iBAAiB,EAAE,gBAAgB,EAAE,WAAW;EAChD,cAAc;AAChB;AACA,yBAAyB,kBAAkB,EAAE,gBAAgB,EAAE,cAAc,EAAE,eAAe,EAAE;AAChG,yBAAyB,kBAAkB,EAAE,cAAc,EAAE,SAAS,EAAE;;AAExE;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;EACzC,kCAAkC;EAClC,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,4CAA4C;EAC5C,0BAA0B;AAC5B;AACA,gCAAgC,kCAAkC,EAAE;AACpE,iCAAiC,sBAAsB,EAAE;AACzD,oBAAoB,YAAY,EAAE,mBAAmB,EAAE;AACvD,gBAAgB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,sBAAsB,EAAE,oCAAoC,EAAE;AACjI,gBAAgB,iBAAiB,EAAE,cAAc,EAAE;;AAEnD,4EAA4E;AAC5E;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,iDAAiD;AACnD;AACA,4BAA4B,UAAU,UAAU,EAAE,EAAE,MAAM,aAAa,EAAE,EAAE;;AAE3E,kBAAkB,kBAAkB,EAAE,cAAc,EAAE,gBAAgB,EAAE;;AAExE;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,oBAAoB;EACpB,oCAAoC;EACpC,0CAA0C;AAC5C;AACA;EACE,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,kBAAkB,EAAE,gBAAgB,EAAE,WAAW;AACnD;AACA,0BAA0B,kBAAkB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAChF;EACE,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;EAChC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA,kBAAkB,iBAAiB,EAAE,iBAAiB,EAAE,cAAc,EAAE,gBAAgB,EAAE;;AAE1F;EACE,aAAa;EACb,gCAAgC;EAChC,MAAM;EACN,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,OAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA,0CAA0C,UAAU,EAAE;AACtD,gDAAgD,uBAAuB,EAAE;AACzE,gDAAgD,iCAAiC,EAAE,kBAAkB,EAAE;;AAEvG;EACE,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;EAC5B,qCAAqC;AACvC;AACA,uBAAuB,kCAAkC,EAAE;AAC3D,yBAAyB,OAAO,UAAU,EAAE,2BAA2B,EAAE,EAAE,KAAK,UAAU,EAAE,eAAe,EAAE,EAAE;;AAE/G;EACE,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,kCAAkC;EAClC,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,kBAAkB,EAAE,gBAAgB,EAAE,cAAc;EACpD,cAAc;AAChB;AACA,uBAAuB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AAC1I,uBAAuB,iBAAiB,EAAE,cAAc,EAAE,kBAAkB,EAAE;AAC9E,uBAAuB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,iBAAiB,EAAE;;AAE7F;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;AACA,mCAAmC,cAAc,EAAE,gBAAgB,EAAE;AACrE,4BAA4B,cAAc,EAAE;AAC5C,4CAA4C,cAAc,EAAE;;AAE5D,uBAAuB,WAAW,EAAE,kCAAkC,EAAE;;AAExE;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;AACA,sCAAsC,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACzF,sCAAsC,iBAAiB,EAAE,gBAAgB,EAAE,WAAW,EAAE;;AAExF,4EAA4E;AAC5E;EACE,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,wEAAwE;AAC1E;;AAEA;EACE,kBAAkB;EAClB,YAAY,EAAE,aAAa;EAC3B,kBAAkB;EAClB,gFAAgF;EAChF,oBAAoB;EACpB,iDAAiD;AACnD;AACA,4BAA4B,UAAU,mBAAmB,EAAE,UAAU,EAAE,EAAE,MAAM,sBAAsB,EAAE,YAAY,EAAE,EAAE;;AAEvH;EACE,YAAY,EAAE,aAAa;EAC3B,kBAAkB;EAClB,UAAU;AACZ;AACA,mBAAmB,WAAW,EAAE,YAAY,EAAE;;AAE9C;EACE,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,6EAA6E;AAC/E;AACA,6BAA6B,KAAK,oBAAoB,EAAE,EAAE;;AAE1D;EACE,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,6EAA6E;AAC/E;AACA,4BAA4B,KAAK,oBAAoB,EAAE,EAAE;;AAEzD;EACE,mCAAmC;EACnC,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,0CAA0C;AAC5C;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,wCAAwC;AAC1C;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,0CAA0C;EAC1C,eAAe;AACjB;AACA;EACE,YAAY,EAAE,WAAW;EACzB,oBAAoB;EACpB,iCAAiC;EACjC,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,8CAA8C;AAChD;AACA,8BAA8B,OAAO,WAAW,EAAE,EAAE,KAAK,SAAS,EAAE,EAAE;AACtE,2BAA2B,kBAAkB,EAAE,cAAc,EAAE","sourcesContent":["/* ── Root ─────────────────────────────────────────────────────────────── */\n.dsd-root {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  font-family: 'Epilogue', 'Inter', sans-serif;\n  background: #060c16;\n  color: #f1f5f9;\n  overflow: hidden;\n}\n\n.dsd-screen {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  animation: dsd-fade-in 0.4s cubic-bezier(0.22, 0.61, 0.36, 1) both;\n}\n\n@keyframes dsd-fade-in {\n  from { opacity: 0; transform: translateY(16px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n/* ── Idle Screen ──────────────────────────────────────────────────────── */\n.dsd-idle {\n  align-items: center;\n  justify-content: center;\n  background: radial-gradient(ellipse at 30% 40%, #0f2744 0%, #060c16 60%),\n              radial-gradient(ellipse at 75% 65%, #0c1f3a 0%, transparent 55%);\n}\n\n.dsd-idle-orb {\n  position: absolute;\n  border-radius: 50%;\n  filter: blur(80px);\n  opacity: 0.25;\n  pointer-events: none;\n}\n.dsd-idle-orb-1 { width: 480px; height: 480px; background: #1d4ed8; top: -120px; left: -80px; animation: dsd-float 8s ease-in-out infinite; }\n.dsd-idle-orb-2 { width: 360px; height: 360px; background: #7c3aed; bottom: -80px; right: -60px; animation: dsd-float 10s ease-in-out infinite reverse; }\n.dsd-idle-orb-3 { width: 240px; height: 240px; background: #0369a1; top: 50%; right: 20%; animation: dsd-float 12s ease-in-out infinite 2s; }\n\n@keyframes dsd-float {\n  0%, 100% { transform: translateY(0) scale(1); }\n  50%       { transform: translateY(-30px) scale(1.05); }\n}\n\n.dsd-idle-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n  text-align: center;\n  padding: 0 24px;\n}\n\n.dsd-idle-avatar {\n  width: 96px;\n  height: 96px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #1d4ed8, #7c3aed);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 2.4rem;\n  font-weight: 800;\n  color: #fff;\n  box-shadow: 0 0 0 12px rgba(29, 78, 216, 0.12), 0 20px 60px rgba(0,0,0,0.5);\n  margin-bottom: 8px;\n}\n\n.dsd-idle-store {\n  font-size: clamp(2rem, 5vw, 3.6rem);\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  color: #fff;\n  margin: 0;\n}\n\n.dsd-idle-tagline {\n  font-size: 1.1rem;\n  color: #94a3b8;\n  margin: 0;\n}\n\n.dsd-idle-dots {\n  display: flex;\n  gap: 8px;\n  margin-top: 8px;\n}\n.dsd-idle-dots span {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #3b82f6;\n  animation: dsd-pulse 1.4s ease-in-out infinite;\n}\n.dsd-idle-dots span:nth-child(2) { animation-delay: 0.2s; }\n.dsd-idle-dots span:nth-child(3) { animation-delay: 0.4s; }\n@keyframes dsd-pulse { 0%,100% { opacity: 0.3; transform: scale(0.85); } 50% { opacity: 1; transform: scale(1); } }\n\n.dsd-idle-mode-btn {\n  position: absolute;\n  bottom: 24px;\n  right: 24px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 18px;\n  border-radius: 999px;\n  border: 1px solid rgba(255,255,255,0.12);\n  background: rgba(255,255,255,0.06);\n  color: #94a3b8;\n  font-size: 0.8rem;\n  font-weight: 500;\n  cursor: pointer;\n  backdrop-filter: blur(8px);\n  transition: background 0.2s, color 0.2s, border-color 0.2s;\n}\n.dsd-idle-mode-btn:hover { background: rgba(255,255,255,0.12); color: #e2e8f0; border-color: rgba(255,255,255,0.2); }\n\n/* Continue button shown after phone lookup result */\n.dsd-phone-continue-btn {\n  margin-top: 28px;\n  padding: 16px 48px;\n  border-radius: 999px;\n  border: none;\n  background: linear-gradient(135deg, #6366f1, #8b5cf6);\n  color: #fff;\n  font-size: 1.1rem;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  cursor: pointer;\n  box-shadow: 0 4px 24px rgba(99,102,241,0.35);\n  transition: transform 0.15s, box-shadow 0.15s;\n}\n.dsd-phone-continue-btn:hover { transform: translateY(-2px); box-shadow: 0 8px 32px rgba(99,102,241,0.5); }\n.dsd-phone-continue-btn:active { transform: translateY(0); }\n\n/* ── Phone Screen ─────────────────────────────────────────────────────── */\n.dsd-phone {\n  align-items: center;\n  justify-content: flex-start;\n  padding: 40px 24px 80px;\n  gap: 28px;\n  background: radial-gradient(ellipse at 50% 0%, #0f2744 0%, #060c16 70%);\n  overflow-y: auto;\n}\n\n.dsd-phone-header {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.dsd-phone-store { font-size: 0.85rem; font-weight: 600; color: #60a5fa; letter-spacing: 0.08em; text-transform: uppercase; margin: 0; }\n.dsd-phone-title { font-size: clamp(1.5rem, 3vw, 2.2rem); font-weight: 800; margin: 0; color: #f8fafc; }\n.dsd-phone-sub   { font-size: 0.95rem; color: #94a3b8; margin: 0; }\n\n.dsd-phone-display-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 72px;\n  padding: 16px 32px;\n  border-radius: 16px;\n  background: rgba(255,255,255,0.05);\n  border: 1.5px solid rgba(255,255,255,0.1);\n  width: 100%;\n  max-width: 420px;\n}\n.dsd-phone-placeholder { font-size: 1.6rem; letter-spacing: 0.25em; color: #475569; }\n.dsd-phone-value { font-size: 2rem; font-weight: 700; letter-spacing: 0.18em; color: #f1f5f9; }\n.dsd-phone-searching {\n  position: absolute;\n  bottom: 0; left: 0; right: 0;\n  height: 3px;\n  border-radius: 0 0 16px 16px;\n  background: linear-gradient(90deg, transparent, #60a5fa, transparent);\n  animation: dsd-scan 1.2s linear infinite;\n}\n@keyframes dsd-scan { 0% { background-position: -200% 0; } 100% { background-position: 200% 0; } }\n\n.dsd-phone-result {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 18px 24px;\n  border-radius: 16px;\n  width: 100%;\n  max-width: 420px;\n  animation: dsd-fade-in 0.35s ease both;\n}\n.dsd-phone-result-found { background: rgba(34, 197, 94, 0.12); border: 1px solid rgba(34, 197, 94, 0.25); }\n.dsd-phone-result-new   { background: rgba(96, 165, 250, 0.1);  border: 1px solid rgba(96, 165, 250, 0.2); color: #93c5fd; font-size: 0.95rem; }\n\n.dsd-phone-result-avatar {\n  width: 48px; height: 48px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #16a34a, #15803d);\n  display: flex; align-items: center; justify-content: center;\n  font-size: 1.3rem; font-weight: 800; color: #fff;\n  flex-shrink: 0;\n}\n.dsd-phone-result-name { font-size: 1.05rem; font-weight: 700; color: #f0fdf4; margin: 0 0 4px; }\n.dsd-phone-result-pts  { font-size: 0.85rem; color: #86efac; margin: 0; }\n\n.dsd-keypad {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n  width: 100%;\n  max-width: 380px;\n}\n.dsd-key {\n  height: 72px;\n  border-radius: 14px;\n  border: 1.5px solid rgba(255,255,255,0.1);\n  background: rgba(255,255,255,0.06);\n  color: #f1f5f9;\n  font-size: 1.6rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.12s, transform 0.1s;\n  backdrop-filter: blur(6px);\n}\n.dsd-key:hover:not(:disabled) { background: rgba(255,255,255,0.12); }\n.dsd-key:active:not(:disabled) { transform: scale(0.95); }\n.dsd-key:disabled { opacity: 0.4; cursor: not-allowed; }\n.dsd-key-skip { font-size: 1rem; font-weight: 700; color: #94a3b8; letter-spacing: 0.04em; border-color: rgba(255,255,255,0.07); }\n.dsd-key-back { font-size: 1.4rem; color: #94a3b8; }\n\n/* ── Cart Screen ──────────────────────────────────────────────────────── */\n.dsd-cart {\n  background: #070d17;\n  overflow: hidden;\n}\n\n.dsd-cart-topbar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 24px;\n  background: rgba(255,255,255,0.03);\n  border-bottom: 1px solid rgba(255,255,255,0.07);\n  flex-shrink: 0;\n}\n\n.dsd-live-badge {\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: #4ade80;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  animation: dsd-live-pulse 2s ease-in-out infinite;\n}\n@keyframes dsd-live-pulse { 0%,100% { opacity: 1; } 50% { opacity: 0.55; } }\n\n.dsd-cart-count { font-size: 0.85rem; color: #64748b; font-weight: 500; }\n\n.dsd-cart-customer-pill {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 14px 6px 6px;\n  border-radius: 999px;\n  background: rgba(59, 130, 246, 0.12);\n  border: 1px solid rgba(59, 130, 246, 0.25);\n}\n.dsd-cart-customer-av {\n  width: 28px; height: 28px;\n  border-radius: 50%;\n  background: #1d4ed8;\n  display: flex; align-items: center; justify-content: center;\n  font-size: 0.78rem; font-weight: 800; color: #fff;\n}\n.dsd-cart-customer-name { font-size: 0.85rem; font-weight: 600; color: #93c5fd; }\n.dsd-cart-loyalty-chip {\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: rgba(59,130,246,0.2);\n  color: #60a5fa;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n.dsd-cart-store { margin-left: auto; font-size: 0.8rem; color: #334155; font-weight: 600; }\n\n.dsd-cart-body {\n  display: grid;\n  grid-template-columns: 1fr 340px;\n  gap: 0;\n  flex: 1;\n  overflow: hidden;\n}\n\n.dsd-cart-items-col {\n  overflow: hidden;\n  border-right: 1px solid rgba(255,255,255,0.06);\n  display: flex;\n  flex-direction: column;\n}\n\n.dsd-cart-items-list {\n  overflow-y: auto;\n  flex: 1;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n.dsd-cart-items-list::-webkit-scrollbar { width: 4px; }\n.dsd-cart-items-list::-webkit-scrollbar-track { background: transparent; }\n.dsd-cart-items-list::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.1); border-radius: 4px; }\n\n.dsd-cart-item {\n  display: grid;\n  grid-template-columns: 32px 1fr 56px 96px;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 12px;\n  border-radius: 10px;\n  transition: background 0.15s;\n  animation: dsd-item-in 0.3s ease both;\n}\n.dsd-cart-item:hover { background: rgba(255,255,255,0.04); }\n@keyframes dsd-item-in { from { opacity: 0; transform: translateX(-8px); } to { opacity: 1; transform: none; } }\n\n.dsd-cart-item-num {\n  width: 28px; height: 28px;\n  border-radius: 50%;\n  background: rgba(255,255,255,0.06);\n  display: flex; align-items: center; justify-content: center;\n  font-size: 0.75rem; font-weight: 700; color: #64748b;\n  flex-shrink: 0;\n}\n.dsd-cart-item-name  { font-size: 1rem; font-weight: 500; color: #e2e8f0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }\n.dsd-cart-item-qty   { font-size: 0.9rem; color: #64748b; text-align: center; }\n.dsd-cart-item-price { font-size: 1rem; font-weight: 700; color: #f1f5f9; text-align: right; }\n\n.dsd-cart-summary-col {\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  overflow-y: auto;\n  background: rgba(0,0,0,0.2);\n}\n\n.dsd-cart-summary-card {\n  background: rgba(255,255,255,0.04);\n  border: 1px solid rgba(255,255,255,0.08);\n  border-radius: 16px;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.dsd-summary-title {\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: #475569;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  padding-bottom: 10px;\n  border-bottom: 1px solid rgba(255,255,255,0.06);\n}\n\n.dsd-summary-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.92rem;\n  color: #94a3b8;\n}\n.dsd-summary-row span:last-child { color: #cbd5e1; font-weight: 500; }\n.dsd-summary-row-discount { color: #4ade80; }\n.dsd-summary-row-discount span:last-child { color: #4ade80; }\n\n.dsd-summary-divider { height: 1px; background: rgba(255,255,255,0.08); }\n\n.dsd-summary-total {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 4px;\n}\n.dsd-summary-total span:first-child { font-size: 1rem; font-weight: 700; color: #f1f5f9; }\n.dsd-summary-total span:last-child  { font-size: 1.7rem; font-weight: 800; color: #fff; }\n\n/* ── Success Screen ───────────────────────────────────────────────────── */\n.dsd-success {\n  align-items: center;\n  justify-content: center;\n  gap: 24px;\n  text-align: center;\n  padding: 40px;\n  background: radial-gradient(ellipse at 50% 40%, #052e16 0%, #060c16 65%);\n}\n\n.dsd-success-glow {\n  position: absolute;\n  width: 480px; height: 480px;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(34, 197, 94, 0.18) 0%, transparent 70%);\n  pointer-events: none;\n  animation: dsd-glow-pulse 2s ease-in-out infinite;\n}\n@keyframes dsd-glow-pulse { 0%,100% { transform: scale(1); opacity: 1; } 50% { transform: scale(1.15); opacity: 0.7; } }\n\n.dsd-success-ring {\n  width: 120px; height: 120px;\n  position: relative;\n  z-index: 1;\n}\n.dsd-success-svg { width: 100%; height: 100%; }\n\n.dsd-success-circle {\n  stroke: #22c55e;\n  stroke-dasharray: 151;\n  stroke-dashoffset: 151;\n  transform-origin: 50% 50%;\n  animation: dsd-circle-draw 0.65s cubic-bezier(0.65, 0, 0.45, 1) 0.1s forwards;\n}\n@keyframes dsd-circle-draw { to { stroke-dashoffset: 0; } }\n\n.dsd-success-check {\n  stroke: #22c55e;\n  stroke-dasharray: 60;\n  stroke-dashoffset: 60;\n  animation: dsd-check-draw 0.35s cubic-bezier(0.65, 0, 0.45, 1) 0.75s forwards;\n}\n@keyframes dsd-check-draw { to { stroke-dashoffset: 0; } }\n\n.dsd-success-title {\n  font-size: clamp(1.8rem, 4vw, 3rem);\n  font-weight: 800;\n  color: #fff;\n  margin: 0;\n  animation: dsd-fade-in 0.5s ease 0.8s both;\n}\n.dsd-success-sub {\n  font-size: 1.05rem;\n  color: #86efac;\n  margin: 0;\n  animation: dsd-fade-in 0.5s ease 1s both;\n}\n.dsd-success-amount {\n  font-size: clamp(2rem, 5vw, 3.5rem);\n  font-weight: 900;\n  color: #4ade80;\n  letter-spacing: -0.02em;\n  animation: dsd-fade-in 0.5s ease 1.1s both;\n}\n\n.dsd-success-timer-wrap {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  animation: dsd-fade-in 0.5s ease 1.3s both;\n  margin-top: 8px;\n}\n.dsd-success-timer-bar {\n  width: 200px; height: 3px;\n  border-radius: 999px;\n  background: rgba(255,255,255,0.1);\n  overflow: hidden;\n}\n.dsd-success-timer-fill {\n  height: 100%;\n  background: #22c55e;\n  border-radius: 999px;\n  animation: dsd-timer-shrink 7s linear forwards;\n}\n@keyframes dsd-timer-shrink { from { width: 100%; } to { width: 0%; } }\n.dsd-success-timer-label { font-size: 0.78rem; color: #475569; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
